namespace $.$$ {

	export class $shm_hitalama_map_widget_float_iframe extends $.$shm_hitalama_map_widget_float_iframe {

		uri_used() {
			return this.widget().code().split( /\r\n|\r|\n/ ).length === 1
		}

		html_use() {
			return !this.uri_used()
		}

		code_html_widget() {
			const widget = this.widget().code_widget()
			if( widget?.type() !== 'code_html' ) return null
			return widget
		}

		@ $mol_mem
		html_manual( next?: string | null ) {
			return next ?? null
		}

		html_ready() {
			if( !this.html_use() ) return true

			const code = this.code_html_widget()
			if( !code ) return true

			return code.enabled() || this.code_html_manual() !== null
		}

		code_view() {
			const widget = this.code_html_widget()
			if( !widget ) return null

			return ( widget.view() ?? this.Map_page().Widget( widget.link() ).Sub() ) as
				| $shm_hitalama_map_widget_float_code_html
				| null
		}

		widget_link_str(): string {
			return this.widget().link_str()
		}
		
		@ $mol_mem
		pool_active() {
			if( !this.hovered() ) return false
			const iframe = this.Iframe().dom_node_actual() as HTMLIFrameElement
			if( document.activeElement === iframe ) {
				this.selected( true )
			}
			$mol_state_time.now( 100 )
			return true
		}

		mouseenter_handler = $mol_wire_async( (event: Event) => {
			this.hovered( true )
			this.Map_page().Dragger().widget(null)
		})

		wheel_handler = $mol_wire_async( (event: Event) => {
			console.log('wheelevent', event)
		})

		@ $mol_action
		iframe_on_load() {
			try {
				const iframe = this.Iframe().dom_node_actual() as HTMLIFrameElement
				
				// const mouseenter = new $mol_dom_listener(
				// 	iframe, 'mouseenter', this.mouseenter_handler,
				// )
				// const wheel = new $mol_dom_listener(
				// 	iframe, 'wheel', this.wheel_handler,
				// )

				if( !this.title() ) {
					this.title( iframe.contentWindow?.document.title ) 
				}
			} catch (error) {
				console.error( error )
				// if( !this.title() ) {
				// 	this.iframe_title( this.uri() ) 
				// }
			}
		}

		@ $mol_mem
		iframe_title( next?: string ): string {
			if( next ) return this.title( next )
			return this.uri() ?? ''
			// return next ?? this.uri() ?? ''
		}
		
		@ $mol_mem
		text( next?: string ): string {
			return this.widget().code( next )
		}
		
		@ $mol_mem
		uri(): string {
			if( !this.uri_used() ) return ''
			return this.widget().code() ?? ''
		}

		@ $mol_mem
		html() {
			if( this.uri_used() ) {
				return null
			}

			const code = this.code_html_widget()
			if( code && !code.enabled() ) {
				const html = this.code_html_manual()
				if( html !== null ) setTimeout( ()=> this.reload_iframe(), 0)
				return html
			}

			const html = this.html_prepare()
			setTimeout( ()=> this.reload_iframe(), 0)
			return html
		}

		code_html_manual() {
			const html = this.code_view()?.Bench().Process().state()
			return typeof html === 'string' ? html : null
		}

		html_prepare() {
			const text = this.widget().code()

			try {
				const deps_code = this.map().runtime().extract_reactive_deps( text )
				if( deps_code ) {
					this.map().execute( deps_code )
				}
			} catch (error) {
				console.error( error )
			}

			return this.map().prepare_html( text )
		}

		run_click() {
			this.code_view()?.run_click()
			if( this.code_html_widget() ) return

			this.run_html()
		}

		run_html() {
			this.html_manual( this.html_prepare() )
			setTimeout( ()=> this.reload_iframe(), 0)
		}

		reload_iframe() {
			const el = this.Iframe().dom_node_actual() as HTMLIFrameElement
			if( this.uri_used() ) {
				el.removeAttribute( 'srcdoc' )
				el.src = this.uri()
				return
			}
			el.srcdoc += ''
		}

		@ $mol_mem
		blocker(): readonly ( any )[] {
			return (this.Map_page().some_transforming()) ? super.blocker() : []
		}

		@ $mol_mem
		editing(): boolean {
			return false
		}

		@ $mol_mem
		tg_post() {
			const match = this.uri().match( /https:\/\/t\.me\/(.+)/ )
			return match?.[1]
		}

		@ $mol_mem
		tg_post_script() {
			const tg_post = this.tg_post()
			if( !tg_post ) return []

			const script = document.createElement( 'script' )
			script.setAttribute( 'src', 'https://telegram.org/js/telegram-widget.js?22' )
			script.setAttribute( 'data-telegram-post', tg_post )
			script.setAttribute( 'data-width', '100%' )
			script.setAttribute( 'async', '' )
			return [ script ]
		}

		@ $mol_mem
		iframe_content() {
			if( !this.html_ready() ) return [ this.Run() ]
			return this.tg_post() ? [ this.Tg_post_dom() ] : [ this.Iframe() ]
		}
		
	}

}
